<template>
	<EditableTextField
		ref="name"
		:text="textLocal"
		@blur="saveAndBlur"
		@onSave="saveAndBlur"
		:isEditing.sync="isEditing"
		@keydown.enter="saveAndBlur"
		@keydown.escape="saveAndBlur"
		placeholder="Enter Connection Name"
		class="editable-text-field text-overflow-ellipsis mr-4"
	/>
</template>

<script>
import { mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import EditableTextField from '@/components/common/EditableTextField';
import { updateUserCredentialsName } from '@/store/modules/credentials/actions';
export default {
	name: 'ConnectionNameEditableTextField',
	components: {
		EditableTextField,
	},
	props: {
		text: { type: String },
		id: { type: [String, Number] },
	},
	methods: {
		...mapActions([updateUserCredentialsName.fullPath]),
		saveAndBlur(newText) {
			this.$refs.name.blur();
			this.saveName(newText);
		},

		saveName(newText) {
			this.isEditing = false;
			this.saveConnectionName(newText);
		},
		setIsEditing(newV) {
			// Trigered from parent
			this.isEditing = newV;
		},
		saveConnectionName(newText) {
			this[updateUserCredentialsName.fullPath]({ id: this.id, name: newText });
		},
	},
	watch: {
		text: {
			handler(newV) {
				if (newV) {
					this.textLocal = newV;
				}
			},
			immediate: true,
			deep: true,
		},
		textLocal: {
			handler: debounce(function (newV, oldV) {
				if (oldV !== undefined) {
					this.saveConnectionName(newV);
				}
			}, 400),
		},
	},
	data() {
		return {
			textLocal: '',
			isEditing: false,
		};
	},
};
</script>

<style scoped lang="scss">
.editable-text-field {
	&::v-deep {
		&.v-text-field {
			> .v-input__control > .v-input__slot {
				height: 17px;
				font-weight: 600;
				font-size: 12px !important;
				color: var(--primary-font-color);
				&:before {
					border: none;
				}

				&:after {
					border-width: 1px !important;
					border-color: var(--primary-color);
				}
			}

			&.v-input--is-disabled,
			&.v-input--is-disabled input {
				opacity: 1 !important;
				color: #3e495a !important;
			}
		}
	}
}
.text-field-container {
	width: 100%;
}
</style>
